import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
 	getTransactions : createAction("getTransactions"),	
}

export default actionTypes;